import { createContext, useState, useEffect } from "react";
export const SidebarContext = createContext();

export const SidebarProvider = ({ children }) => {
  const [isResponsive, setIsResponsive] = useState(
    localStorage.getItem("sidebarResponsive") === "true"
  );

  useEffect(() => {
    localStorage.setItem("sidebarResponsive", isResponsive);
  }, [isResponsive]);

  return (
    <SidebarContext.Provider value={{ isResponsive, setIsResponsive }}>
      {children}
    </SidebarContext.Provider>
  );
};
